promokit.layer({
  el: '#layer-new-look',
  buttons: '.p-sec3-1__detail--1, .p-sec3-1__detail--3, .p-sec3-1__detail--4',
});
promokit.layer({
  el: '#layer-new-weapon',
  buttons: '.p-sec3-1__detail--2',
});


export default {
  id: '#section3'
};



// WEBPACK FOOTER //
// ./src/js/bingo/section-3.js